// // src/utils/permissions/permissionChecker.ts

// import React from "react";

// export type PermissionAction = "create" | "read" | "update" | "delete" | "export";

// // ==========================================
// // DUMMY PERMISSIONS DATA (FOR TESTING)
// // ==========================================
// const dummyPermissions = {
//   "data": {
//     "permissions": {
//       "modules": {
//         "Onboarding": {
//           "moduleInfo": {
//             "name": "Organisation Setup",
//             "description": "Configure organization structure and settings"
//           },
//           "submodules": {
//             "MANAGEMENT": {
//               "Dashboard": {
//                 "defaultRoute": "/onboarding/system-admin/dashboard",
//                 "routes": ["/onboarding/system-admin/dashboard"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               },
//               "Organisation Setup": {
//                 "defaultRoute": "/onboarding/org-setup/dashoard",
//                 "routes": ["/onboarding/org-setup/dashoard"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": false
//               }
//             },
//             "UTILITY SETUP": {
//               "Utility Management": {
//                 "defaultRoute": "/utility/utility-setup/dashoard",
//                 "routes": [
//                   "/utility/utility-setup/dashoard",
//                   "/onboarding/utility-setup/dashoard",
//                   "/onboarding/utility-setup/core-settings",
//                   "/onboarding/utility-setup/calendar",
//                   "/onboarding/utility-setup/id-config",
//                   "/onboarding/utility-setup/user-management",
//                   "/onboarding/utility-setup/service-area"
//                 ],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               },
//               "Plans & Tariffs": {
//                 "defaultRoute": "/plan-tarrif/plan-tarrif-landing",
//                 "routes": [
//                   "/onboarding/utility-setup/tariff",
//                   "/onboarding/utility-setup/plan-tarrif-landing",
//                   "/onboarding/utility-setup/plan-tarrif-details",
//                   "/plan-tarrif/plan-tarrif-landing",
//                   "/plan-tarrif/plan-tarrif-details",
//                   "/plan-tarrif/tariff",
//                   "/plan-tarrif/plan"
//                 ],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               },
//               "Service Areas": {
//                 "defaultRoute": "/utility/utility-setup/service-area",
//                 "routes": [
//                   "/onboarding/utility-setup/service-area",
//                   "/utility/utility-setup/service-area"
//                 ],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "DATA MANAGEMENT": {
//               "Migration": {
//                 "defaultRoute": "/onboarding/data-migration/data-cards",
//                 "routes": [
//                   "/onboarding/data-migration/data-cards",
//                   "/onboarding/data-migration/data-setup",
//                   "/onboarding/data-migration/data-selection",
//                   "/onboarding/data-migration/file-upload",
//                   "/onboarding/data-migration/data-mapping",
//                   "/onboarding/data-migration/data-validation",
//                   "/onboarding/data-migration/migration-execution"
//                 ],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": false
//               }
//             },
//             "INTEGRATIONS": {
//               "Payment": {
//                 "defaultRoute": "/integrations/payment",
//                 "routes": ["/integrations/payment"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": false
//               },
//               "Smart Meter OEM": {
//                 "defaultRoute": "/integrations/smart-meter",
//                 "routes": ["/integrations/smart-meter"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": false
//               }
//             }
//           }
//         },
//         "CX": {
//           "moduleInfo": {
//             "name": "Consumer Services",
//             "description": "Customer account and service management"
//           },
//           "submodules": {
//             "MANAGEMENT": {
//               "Dashboard": {
//                 "defaultRoute": "/cx/dashboard",
//                 "routes": ["/cx/dashboard"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Accounts": {
//                 "defaultRoute": "/cx/consumer-management",
//                 "routes": ["/cx/consumer-management","/cx/consumer-onboarding"],
//                 "canRead": false,
//                 "canCreate": false,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": false
//               },
//               "Payments": {
//                 "defaultRoute": "/cx/payments",
//                 "routes": ["/cx/payments"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Outstandings": {
//                 "defaultRoute": "/cx/outstanding",
//                 "routes": ["/cx/outstanding"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Services": {
//                 "defaultRoute": "/cx/services",
//                 "routes": ["/cx/services", "/cx/account-services"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Complaints": {
//                 "defaultRoute": "/cx/complaints",
//                 "routes": ["/cx/complaints"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "LIFECYCLE": {
//               "Onboarding": {
//                 "defaultRoute": "/cx/consumer-onboarding",
//                 "routes": [
//                   "/cx/consumer-onboarding",
//                   "/workflow/inspection",
//                   "/workflow/approval",
//                   "/workflow/installation",
//                   "/workflow/activation"
//                 ],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Disconnection": {
//                 "defaultRoute": "/cx/disconnections",
//                 "routes": ["/cx/disconnections"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Reconnect": {
//                 "defaultRoute": "/cx/reconnections",
//                 "routes": ["/cx/reconnections"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Transfer": {
//                 "defaultRoute": "/cx/transfer",
//                 "routes": ["/cx/transfer"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "SETTINGS": {
//               "Settings": {
//                 "defaultRoute": "/cx/settings",
//                 "routes": ["/cx/settings"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": false
//               }
//             }
//           }
//         },
//         "MX": {
//           "moduleInfo": {
//             "name": "Meter Data",
//             "description": "Meter reading and consumption data"
//           },
//           "submodules": {
//             "MANAGEMENT": {
//               "Dashboard": {
//                 "defaultRoute": "/mx/dashboard",
//                 "routes": ["/mx/dashboard", "/mx/metermaster", "/mx"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "DEVICE MANAGEMENT": {
//               "Meter": {
//                 "defaultRoute": "/mx/device-management/meter",
//                 "routes": ["/mx/device-management/meter"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Inventory": {
//                 "defaultRoute": "/mx/device-management/inventory",
//                 "routes": ["/mx/device-management/inventory"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Service Orders": {
//                 "defaultRoute": "/mx/device-management/service-order",
//                 "routes": ["/mx/device-management/service-order"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "METER READS": {
//               "Routes": {
//                 "defaultRoute": "/mx/routeManagement",
//                 "routes": ["/mx/routeManagement"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               },
//               "Read Cycle": {
//                 "defaultRoute": "/mx/read-cycle",
//                 "routes": ["/mx/read-cycle"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Manual Reads": {
//                 "defaultRoute": "/mx/meterread/manual-meter",
//                 "routes": ["/mx/meterread/manual-meter"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Photo Reads": {
//                 "defaultRoute": "/mx/meterread/photo-meter",
//                 "routes": ["/mx/meterread/photo-meter"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Smart Reads": {
//                 "defaultRoute": "/mx/meterread/smartmeter",
//                 "routes": ["/mx/meterread/smartmeter"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "READING VALIDATIONS": {
//               "Validations": {
//                 "defaultRoute": "/mx/meter-validation",
//                 "routes": ["/mx/meter-validation"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "SETTINGS": {
//               "Meter Read Format": {
//                 "defaultRoute": "/mx/settings/meterread-format",
//                 "routes": ["/mx/settings/meterread-format"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": false
//               },
//               "Manufacturer": {
//                 "defaultRoute": "/mx/manufacturer",
//                 "routes": ["/mx/manufacturer"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               }
//             }
//           }
//         },
//         "BX": {
//           "moduleInfo": {
//             "name": "Billing",
//             "description": "Invoice generation and payment processing"
//           },
//           "submodules": {
//             "MANAGEMENT": {
//               "Dashboard": {
//                 "defaultRoute": "/bx/dashboard",
//                 "routes": ["/bx/dashboard"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "BILL SETUP": {
//               "Bill Cycle": {
//                 "defaultRoute": "/bx/bill-setup/billcycle",
//                 "routes": ["/bx/bill-setup/billcycle"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               },
//               "Bill Template": {
//                 "defaultRoute": "/bx/bill-setup/billtemplate",
//                 "routes": ["/bx/bill-setup/billtemplate"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": false
//               }
//             },
//             "BILL GENERATION": {
//               "Bulk Billing": {
//                 "defaultRoute": "/bx/create-bill-generation",
//                 "routes": ["/bx/create-bill-generation"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Single Billing": {
//                 "defaultRoute": "/bx/single-bill-generation",
//                 "routes": ["/bx/single-bill-generation"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "BILLING": {
//               "History": {
//                 "defaultRoute": "/bx/history",
//                 "routes": ["/bx/history"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Master": {
//                 "defaultRoute": "/bx/search",
//                 "routes": ["/bx/search"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "BILL PRINTING": {
//               "Printing & Distribution": {
//                 "defaultRoute": "/bx/printing-distribution",
//                 "routes": ["/bx/printing-distribution"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "SETTINGS": {
//               "GL Codes": {
//                 "defaultRoute": "/bx/gl-code",
//                 "routes": ["/bx/gl-code"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": false
//               }
//             }
//           }
//         },
//         "WX": {
//           "moduleInfo": {
//             "name": "Service Order",
//             "description": "Work order creation and tracking"
//           },
//           "submodules": {
//             "MANAGEMENT": {
//               "Dashboard": {
//                 "defaultRoute": "/wx/dashboard",
//                 "routes": ["/wx/dashboard"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               },
//               "Master": {
//                 "defaultRoute": "/service-orders/wx-master",
//                 "routes": ["/service-orders/wx-master", "/bulk-upload"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               },
//               "Field Force": {
//                 "defaultRoute": "/service-orders/field-force",
//                 "routes": ["/wx/fieldforce", "/service-orders/field-force"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             },
//             "DISTRIBUTION": {
//               "Dispatcher": {
//                 "defaultRoute": "/service-orders/dispatcher",
//                 "routes": [
//                   "/service-orders/dispatcher",
//                   "/service-orders/wx-dashboard/create-service-order"
//                 ],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": true,
//                 "canExport": true
//               }
//             },
//             "SETTINGS": {
//               "Workorder": {
//                 "defaultRoute": "/service-orders/settings/workorder",
//                 "routes": [
//                   "/service-orders/settings/workorder",
//                   "/service-orders/settings/fieldforce"
//                 ],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": false
//               }
//             }
//           }
//         },
//         "Call Center": {
//           "moduleInfo": {
//             "name": "Call Center",
//             "description": "Manage customer service call centers"
//           },
//           "submodules": {
//             "MANAGEMENT": {
//               "Dashboard": {
//                 "defaultRoute": "/call-center/dashboard",
//                 "routes": [
//                   "/call-center/dashboard",
//                   "/call-center/payment/create",
//                   "/call-center/services/create",
//                   "/call-center/complaints/create"
//                 ],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "My Performance": {
//                 "defaultRoute": "/call-center/performance",
//                 "routes": ["/call-center/performance"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// };

// // ==========================================
// // PERMISSION CHECKING FUNCTIONS
// // ==========================================

// /**
//  * Normalize route for comparison (remove trailing slashes, lowercase)
//  */
// const normalizeRoute = (route: string): string => {
//   return route.toLowerCase().replace(/\/+$/, '');
// };

// /**
//  * Check if current route matches or is a child of permission route
//  * Examples:
//  * - /cx/consumer-management matches /cx/consumer-management ✓
//  * - /cx/consumer-management/create matches /cx/consumer-management ✓
//  * - /cx/consumer-management/123 matches /cx/consumer-management ✓
//  */
// const isRouteMatch = (currentRoute: string, permissionRoute: string): boolean => {
//   const current = normalizeRoute(currentRoute);
//   const permission = normalizeRoute(permissionRoute);

//   // Exact match
//   if (current === permission) return true;

//   // Prefix match (child route)
//   if (current.startsWith(permission + '/')) return true;

//   return false;
// };

// /**
//  * Find permissions for current route by searching all modules/submodules
//  */
// const findPermissionsForRoute = (currentRoute: string): any | null => {
//   const modules = dummyPermissions?.data?.permissions?.modules;

//   if (!modules) {
//     console.warn('❌ No permissions data available');
//     return null;
//   }

//   // Search through all modules
//   for (const moduleKey of Object.keys(modules)) {
//     const moduleData = modules[moduleKey];
//     const submodules = moduleData.submodules;

//     if (!submodules) continue;

//     // Search through all categories (MANAGEMENT, LIFECYCLE, etc.)
//     for (const categoryKey of Object.keys(submodules)) {
//       const category = submodules[categoryKey];

//       // Search through all submodules in category
//       for (const submoduleName of Object.keys(category)) {
//     const submodule = category[submoduleName];

//         if (!submodule?.routes) continue;

//         // Check if any route in this submodule matches current route
//         for (const route of submodule.routes) {
//           if (isRouteMatch(currentRoute, route)) {
//             console.log(`✅ Permission match found:`, {
//               currentRoute,
//               matchedRoute: route,
//               module: moduleKey,
//               category: categoryKey,
//               submodule: submoduleName,
//               permissions: {
//                 create: submodule.canCreate,
//                 read: submodule.canRead,
//                 update: submodule.canUpdate,
//                 delete: submodule.canDelete,
//                 export: submodule.canExport,
//               }
//             });
//             return submodule;
//           }
//         }
//       }
//     }
//   }

//   console.warn(`❌ No permission match found for route: ${currentRoute}`);
//   return null;
// };

// /**
//  * Main permission checker function
//  * @param currentRoute - Current URL pathname (e.g., /cx/consumer-management/create)
//  * @param action - Action to check (create, read, update, delete, export)
//  * @returns true if action is allowed, false otherwise
//  */
// export const checkPermission = (
//   currentRoute: string,
//   action: PermissionAction
// ): boolean => {
//   try {
//     // Find permissions for this route
//     const permissions = findPermissionsForRoute(currentRoute);

//     if (!permissions) {
//       // No permissions found = HIDE by default (safe approach)
//       console.log(`🚫 Hiding - no permissions found for: ${currentRoute}`);
//       return false;
//     }

//     // Map action to permission field
//     const permissionMap: Record<PermissionAction, string> = {
//       create: 'canCreate',
//       read: 'canRead',
//       update: 'canUpdate',
//       delete: 'canDelete',
//       export: 'canExport',
//     };

//     const permissionKey = permissionMap[action];
//     const hasPermission = permissions[permissionKey] === true;

//     console.log(`🔐 Permission check:`, {
//       route: currentRoute,
//       action,
//       permission: permissionKey,
//       result: hasPermission ? '✅ ALLOWED' : '❌ DENIED'
//     });

//     return hasPermission;

//   } catch (error) {
//     console.error('❌ Error checking permissions:', error);
//     // On error, HIDE (safe default)
//     return false;
//   }
// };

// /**
//  * Detect action from button children text
//  * Used by Button component to automatically determine what action to check
//  */
// export const detectActionFromContent = (
//   children: React.ReactNode
// ): PermissionAction | null => {
//   const childText = typeof children === 'string'
//     ? children.toLowerCase()
//     : React.Children.toArray(children)
//         .filter((child) => typeof child === 'string')
//         .join(' ')
//         .toLowerCase();

//   // Priority order matters - check specific terms first
//   if (childText.includes('delete') || childText.includes('remove')) {
//     return 'delete';
//   }
//   if (childText.includes('view') || childText.includes('show')) {
//     return 'read';
//   }
//   if (childText.includes('export') || childText.includes('download')) {
//     return 'export';
//   }
//   if (childText.includes('edit') || childText.includes('update') || childText.includes('modify') || childText.includes('save changes')) {
//     return 'update';
//   }
//   if (childText.includes('create') || childText.includes('add new') || childText.includes('new ')) {
//     return 'create';
//   }
//   if (childText.includes('add') || childText.includes('submit')) {
//     return 'create'; // Generic add/submit = create
//   }

//   // No action detected - this might be a navigation/cancel/view button
//   return null;
// };

// src/utils/permissions/permissionChecker.ts

import React from "react";

export type PermissionAction =
  | "create"
  | "read"
  | "update"
  | "delete"
  | "export";

// ==========================================
// PERMISSION CHECKING FUNCTIONS
// ==========================================

/**
 * Normalize route for comparison (remove trailing slashes, lowercase)
 */
const normalizeRoute = (route: string): string => {
  return route.toLowerCase().replace(/\/+$/, "");
};

/**
 * Check if current route matches or is a child of permission route
 * Examples:
 * - /cx/consumer-management matches /cx/consumer-management ✓
 * - /cx/consumer-management/create matches /cx/consumer-management ✓
 * - /cx/consumer-management/123 matches /cx/consumer-management ✓
 */

const isRouteMatch = (
  currentRoute: string,
  permissionRoute: string,
): boolean => {
  const normalizeRoute = (route: string) =>
    route?.trim().replace(/^\/+|\/+$/g, ""); // remove leading and trailing slashes

  const current = normalizeRoute(currentRoute);
  const permission = normalizeRoute(permissionRoute);

  // ✅ Exact match
  if (current === permission) return true;

  // ✅ Parameterized route check (e.g., /view/:id)
  if (permission.includes(":")) {
    const regex = new RegExp(
      "^" + permission.replace(/:[^/]+/g, "[^/]+") + "$"
    );
    if (regex.test(current)) return true;
  }

  // ✅ Child route check (e.g., consumer-management/create)
  if (current.startsWith(permission + "/")) return true;

  return false;
};

/**
 * Find permissions for current route by searching all modules/submodules
 * @param currentRoute - Current URL pathname
 * @param permissionsData - Permissions data object from API
 */
const findPermissionsForRoute = (
  currentRoute: string,
  permissionsData: any,
): any | null => {
  const modules = permissionsData?.data?.permissions?.modules;

  if (!modules) {
    console.warn("❌ No permissions data available");
    return null;
  }

  // Search through all modules
  for (const moduleKey of Object.keys(modules)) {
    const moduleData = modules[moduleKey];
    const submodules = moduleData.submodules;

    if (!submodules) continue;

    // Search through all categories (MANAGEMENT, LIFECYCLE, etc.)
    for (const categoryKey of Object.keys(submodules)) {
      const category = submodules[categoryKey];

      // Search through all submodules in category
      for (const submoduleName of Object.keys(category)) {
        const submodule = category[submoduleName];

        if (!submodule?.routes) continue;

        // Check if any route in this submodule matches current route
        for (const route of submodule.routes) {
          if (isRouteMatch(currentRoute, route)) {
            console.log(`✅ Permission match found:`, {
              currentRoute,
              matchedRoute: route,
              module: moduleKey,
              category: categoryKey,
              submodule: submoduleName,
              permissions: {
                create: submodule.canCreate,
                read: submodule.canRead,
                update: submodule.canUpdate,
                delete: submodule.canDelete,
                export: submodule.canExport,
              },
            });
            return submodule;
          }
        }
      }
    }
  }

  console.warn(`❌ No permission match found for route: ${currentRoute}`);
  return null;
};

/**
 * Main permission checker function
 * @param currentRoute - Current URL pathname (e.g., /cx/consumer-management/create)
 * @param action - Action to check (create, read, update, delete, export)
 * @param permissionsData - Permissions data from useGlobalUserPermission hook
 * @returns true if action is allowed, false otherwise
 */
export const checkPermission = (
  currentRoute: string,
  action: PermissionAction,
  permissionsData?: any,
): boolean => {
  try {
    // Find permissions for this route
    const permissions = findPermissionsForRoute(currentRoute, permissionsData);

    if (!permissions) {
      // No permissions found = HIDE by default (safe approach)
      console.log(`🚫 Hiding - no permissions found for: ${currentRoute}`);
      return false;
    }

    // Map action to permission field
    const permissionMap: Record<PermissionAction, string> = {
      create: "canCreate",
      read: "canRead",
      update: "canUpdate",
      delete: "canDelete",
      export: "canExport",
    };

    const permissionKey = permissionMap[action];
    const hasPermission = permissions[permissionKey] === true;

    console.log(`🔐 Permission check:`, {
      route: currentRoute,
      action,
      permission: permissionKey,
      result: hasPermission ? "✅ ALLOWED" : "❌ DENIED",
    });

    return hasPermission;
  } catch (error) {
    console.error("❌ Error checking permissions:", error);
    // On error, HIDE (safe default)
    return false;
  }
};

/**
 * Detect action from button children text
 * Used by Button component to automatically determine what action to check
 */
export const detectActionFromContent = (
  children: React.ReactNode,
): PermissionAction | null => {
  const childText =
    typeof children === "string"
      ? children.toLowerCase()
      : React.Children.toArray(children)
          .filter((child) => typeof child === "string")
          .join(" ")
          .toLowerCase();

  // Priority order matters - check specific terms first
  if (childText.includes("delete") || childText.includes("remove")) {
    return "delete";
  }
  if (childText.includes("view") || childText.includes("show")) {
    return "read";
  }
  if (childText.includes("export") || childText.includes("download")) {
    return "export";
  }
  if (
    childText.includes("edit") ||
    childText.includes("update") ||
    childText.includes("modify") ||
    childText.includes("save changes")
  ) {
    return "update";
  }
  if (
    childText.includes("create") ||
    childText.includes("add new") ||
    childText.includes("new ")
  ) {
    return "create";
  }
  if (childText.includes("add") || childText.includes("submit")) {
    return "create"; // Generic add/submit = create
  }

  // No action detected - this might be a navigation/cancel/view button
  return null;
};
